import moment from "moment-timezone";
import { patch } from "redux/fetch";

export function updateTimezone() {
    const timezone = moment.tz.guess();
    patch("/api/hire/v1/account/", {
        timezone,
        csrf_token: window.csrfToken,
    });
}
